"use client"

import { useEffect } from "react"
import { usePathname } from "@/i18n/navigation"

declare global {
  interface Window {
    umami?: {
      track: (path: string) => void
    }
  }
}

export function Analytics() {
  const pathname = usePathname()
  const umamiWebsiteId = process.env.NEXT_PUBLIC_UMAMI_WEBSITE_ID
  const umamiScriptUrl = process.env.NEXT_PUBLIC_UMAMI_SCRIPT_URL

  // Initialize Umami script
  useEffect(() => {
    if (!umamiWebsiteId || !umamiScriptUrl || typeof window === "undefined") return

    // Check if Umami script is already loaded
    if (document.querySelector(`script[data-website-id="${umamiWebsiteId}"]`)) {
      return
    }

    // Initialize Umami
    const script = document.createElement("script")
    script.async = true
    script.defer = true
    script.src = umamiScriptUrl
    script.setAttribute("data-website-id", umamiWebsiteId)
    document.head.appendChild(script)
  }, [umamiWebsiteId, umamiScriptUrl])

  // Track page views when pathname changes (for SPA navigation)
  useEffect(() => {
    if (umamiWebsiteId && typeof window !== "undefined" && window.umami) {
      window.umami.track(pathname)
    }
  }, [pathname, umamiWebsiteId])

  if (!umamiWebsiteId || !umamiScriptUrl) return null

  return null
}

